import Slider from "react-slick";

import CustomArrow from './CustomArrow';

import i18nService from '../../../services/i18nService';

export default function ColorSelector(props) {
  let colorSlides = []
  props.selectedModel.colors.forEach(color => {
    colorSlides.push(
      <div key={color.id}
        className="Carousel-slide"
        onClick={() => props.selectColor(color)}
        >
        <div
          className="Carousel-slide-image"
          style={{ backgroundImage: `url(${color.production_cover})`}}
          />
        <h2 className="Carousel-slide-title">
          <span className="Carousel-slide-title-pre">{color.name_pre}</span> {color.name} <span className="Carousel-slide-title-post">{color.name_post}</span>
        </h2>
        <p className="Carousel-slide-price"><small>{i18nService.translate(props.locale, 'total')}</small> {color.price_from}</p>
      </div>
    )
  })

  const slickSettings = {
    dots: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction='right' />,
    prevArrow: <CustomArrow direction='left' />
  };

  return (
    <div className="ColorSelector">
      <div className="desktop-only">
        <Slider {...slickSettings} infinite={false} slidesToShow={4}>{colorSlides}</Slider>
      </div>

      <div className="mobile-only">
        <Slider {...slickSettings} infinite={true} slidesToShow={1}>{colorSlides}</Slider>
      </div>
    </div>
  )
}
